var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2_00000007420653683276137850000006198260641501518244_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 187.1 187.1",
    style: {
      enableBackground: "new 0 0 187.1 187.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 96.45,
    x2: 187.1,
    y2: 96.45,
    gradientTransform: "matrix(1 0 0 -1 0 190)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#28AAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006496"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.6,187.1C42,187.1,0,145.1,0,93.6S42,0,93.6,0s93.6,42,93.6,93.6S145.1,187.1,93.6,187.1z M93.6,8.3 c-47,0-85.2,38.2-85.2,85.2s38.2,85.2,85.2,85.2s85.2-38.2,85.2-85.2S140.5,8.3,93.6,8.3L93.6,8.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M127.6,58.6c-1.1,0-2,0.9-2,2v75H67.1c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5h53.5c1.1,0,2-0.9,2-2v-73c0-1.1-0.9-2-2-2 h-61c-1.1,0-2,0.9-2,2v80.5c0,5.2,4.3,9.5,9.5,9.5h60.5c1.1,0,2-0.9,2-2v-77C129.6,59.4,128.7,58.6,127.6,58.6z M67.1,120.6 c-2,0-3.9,0.6-5.5,1.8V51.6h57v69H67.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.6,128.6h-53c-1.1,0-2,0.9-2,2s0.9,2,2,2h53c1.1,0,2-0.9,2-2S121.7,128.6,120.6,128.6z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.88f19922e41891be59e7f93b656ac979.svg";
export { ForwardRef as ReactComponent };